<template>
  <div>
    <ul id="user" v-if="showMenu" class="dropdown-content correzione-drop-down-user">
      <li>
        <router-link :exact-active-class="'main-link-active'" class="nav-link main-link remove-header"
          to="/registration" @click.native="hideHeader">
          <i class="material-icons left">account_box</i> {{ traduzione('item.my.account') }}
        </router-link>
      </li>

      <li>
        <router-link :exact-active-class="'main-link-active'" class="nav-link main-link remove-header" to="/list-events"
          @click.native="hideHeader">
          <i class="material-icons left">event</i> {{ traduzione('item.menu.my.events') }}
        </router-link>
      </li>

      <li>
        <router-link :exact-active-class="'main-link-active'" class="nav-link main-link remove-header"
          to="/changepassword" @click.native="hideHeader">
          <i class="material-icons left">security</i> {{ traduzione('title.reset.password') }}
        </router-link>
      </li>
       <li v-if="showMenu">
        <router-link :exact-active-class="'main-link-active'" class="nav-link main-link remove-header"
          to="/billing" @click.native="hideHeader">
          <i class="material-icons left">attach_money</i> {{ traduzione('item.menu.acquisti') }}
        </router-link>
      </li>

      <li>
        <a class="dropdown-item" @click="logoutAndHideHeader()" href="javascript:void(0)">
          <i class="material-icons left">exit_to_app</i> {{ traduzione('item.menu.logout') }}
        </a>
      </li>
    </ul>

    <ul id="language" class="dropdown-content correzione-drop-down">
      <li v-for="(lingua, code) in translation.getters.avaiable" :key="code">
        <a class="dropdown-item" @click="cambiaLinguaAndHideHeader(code)" href="javascript:void(0)">
          <img :src="lingua.flag" :alt="lingua.language" class="flag-rounded">
        </a>
      </li>
    </ul>

    <ul id="language-mobile" class="dropdown-content correzione-drop-down-mobile">
      <li class="li-lang" v-for="(lingua, code) in translation.getters.avaiable" :key="code">
        <a @click.stop="cambiaChiudiNavAndHideHeader(code)" href="javascript:void(0)">
          <img :src="lingua.flag" :alt="lingua.language" class="flag-rounded">
          <span class="menu-side-bar-language">{{ traduzione(lingua.language)  }}</span>
        </a>
      </li>
    </ul>

    <nav>
      <div class="nav-wrapper body-border">
        <a href="#" @click.native="fullLanguageAndHideHeader" data-target="mobile-demo" class="sidenav-trigger left"><i
            class="material-icons">menu</i></a>

        <a href="/" class="brand-logo left remove-header" title="I GOT U" @click="hideHeader">I GOT <span
            class="brand_red">U<sup>®</sup></span></a>

        <ul class="left hide-on-med-and-down">
          <li>
            <router-link :exact-active-class="'main-link-active'" class="nav-link main-link remove-header" to="/"
              @click.native="hideHeader">
              {{ traduzione('item.menu.home') }}
            </router-link>
          </li>
          <li>
            <router-link :exact-active-class="'main-link-active'" class="nav-link main-link remove-header" to="/about"
              @click.native="hideHeader">
              {{ traduzione('item.menu.one') }}
            </router-link>
          </li>
          <li>
            <router-link :exact-active-class="'main-link-active'" class="nav-link main-link remove-header" to="/pricing"
              @click.native="hideHeader">
              {{ traduzione('item.menu.two') }}
            </router-link>
          </li>
          <li>
            <router-link :exact-active-class="'main-link-active'" class="nav-link main-link remove-header" to="/support"
              @click.native="hideHeader">
              {{ traduzione('item.menu.tre') }}
            </router-link>
          </li>
          <li>
            <router-link :exact-active-class="'main-link-active'" class="nav-link main-link remove-header"
              to="/hire-ipad" @click.native="hideHeader">
              {{ traduzione('item.menu.quat') }}
            </router-link>
          </li>
        </ul>

        <ul class="right hide-on-med-and-down">
          <template v-if="!showMenu">
            <li class="nav-item active">
              <router-link :exact-active-class="'main-link-active'" class="nav-link main-link remove-header"
                to="/registration" @click.native="hideHeader">
                {{ traduzione('item.sign.in') }}
              </router-link>
            </li>

            <li class="nav-item active">
              <router-link :exact-active-class="'main-link-active'" class="nav-link main-link remove-header" to="/login"
                @click.native="hideHeader">
                {{ traduzione('intem.login') }}
              </router-link>
            </li>
          </template>

<li v-if="showMenu">
  <a class="dropdown-trigger" href="javascript:void(0)"
     data-target="user" ref="userDropdownTrigger">

    <span class="username-text">{{ userName }}</span>
    <i class="material-icons right">arrow_drop_down</i>

  </a>
</li>

          <li>
            <a class="dropdown-trigger" href="javascript:void(0)" data-target="language" ref="languageDropdownTrigger">
              <img v-if="currentLanguageData && currentLanguageData.flag" :src="currentLanguageData.flag"
                :alt="currentLanguageData.language" class="flag-rounded">
              <i class="material-icons right">arrow_drop_down</i>
            </a>
          </li>

          <li v-if="showMenu">
            <router-link to="/cart" class="nav-link main-link remove-header" @click.native="chartClick">
              <i class="material-icons">shopping_cart</i>
              <span v-if="cartCount > 0" class="new badge red cart-badge" data-badge-caption="">{{ cartCount }}</span>
            </router-link>
          </li>
        </ul>

      </div>
    </nav>

    <ul class="sidenav" id="mobile-demo" ref="mobileSidenav">
      <li class="titolo-menu-mobile nav-link-mobile">
        <table style="width: 100%;">
          <tr>
            <td style="width: 30%;">
              <img src="img/logo_igotu.png" alt="IgoTu" style="width: 100%;padding:0px;margin: 0px;">
            </td>
            <td>
              <nav>
                <a href="/" class="brand-logo remove-header" title="I GOT U" @click.native="hideHeaderAndCloseSidenav">I GOT <span
                    class="brand_red">U<sup>®</sup></span></a>
              </nav>
            </td>
          </tr>
        </table>
      </li>
      <li v-if="showMenu">
        <router-link @click.native="hideHeaderAndCloseSidenav" :exact-active-class="'main-link-active'"
          class="nav-link main-link remove-header" to="/registration">
          <i class="material-icons left">account_box</i> {{ traduzione('item.my.account') }}
        </router-link>
      </li>
      <li v-if="showMenu">
        <router-link @click.native="hideHeaderAndCloseSidenav" :exact-active-class="'main-link-active'" class="nav-link main-link remove-header" to="/list-events">
          <i class="material-icons left">event</i> {{ traduzione('item.menu.my.events') }}
        </router-link>
      </li>
      <li v-if="showMenu">
        <router-link @click.native="hideHeaderAndCloseSidenav" :exact-active-class="'main-link-active'" class="nav-link main-link remove-header"
          to="/changepassword">
          <i class="material-icons left">security</i> {{ traduzione('title.reset.password') }}
        </router-link>
      </li>
      <li v-if="showMenu">
        <router-link @click.native="hideHeaderAndCloseSidenav" :exact-active-class="'main-link-active'" class="nav-link main-link remove-header"
          to="/billing">
          <i class="material-icons left">attach_money</i> {{ traduzione('item.menu.acquisti') }}
        </router-link>
      </li>
      <li v-if="showMenu">
        <a class="dropdown-item" @click="logoutAndHideHeaderAndCloseSidenav()" href="javascript:void(0)">
          <i class="material-icons left">exit_to_app</i> {{ traduzione('item.menu.logout') }}
        </a>
      </li>

      <li class="divider"></li>

      <li>
        <router-link @click.native="hideHeaderAndCloseSidenav" :exact-active-class="'main-link-active'"
          class="nav-link main-link remove-header" to="/"><i class="material-icons">home</i> {{
            traduzione('item.menu.home') }}</router-link>
      </li>
      <li>
        <router-link @click.native="hideHeaderAndCloseSidenav" :exact-active-class="'main-link-active'"
          class="nav-link main-link nav-link-mobile remove-header" to="/about"><i class="material-icons">help</i> {{
            traduzione('item.menu.one') }}</router-link>
      </li>
      <li><router-link @click.native="hideHeaderAndCloseSidenav" :exact-active-class="'main-link-active'"
          class="nav-link main-link nav-link-mobile remove-header" to="/pricing"><i
            class="material-icons">euro_symbol</i>
          {{
            traduzione('item.menu.two') }}</router-link></li>
      <li><router-link @click.native="hideHeaderAndCloseSidenav" :exact-active-class="'main-link-active'"
          class="nav-link main-link nav-link-mobile remove-header" to="/support"><i class="material-icons">Youtube</i>
          {{
            traduzione('item.menu.tre') }}</router-link></li>
      <li><router-link @click.native="hideHeaderAndCloseSidenav" :exact-active-class="'main-link-active'"
          class="nav-link main-link nav-link-mobile remove-header" to="/hire-ipad"><i
            class="material-icons">phone_iphone</i>
          {{
            traduzione('item.menu.quat') }}</router-link></li>

      <template v-if="!showMenu">
        <li class="nav-item active"><router-link @click.native="hideHeaderAndCloseSidenav"
            :exact-active-class="'main-link-active'" class="nav-link main-link nav-link-mobile remove-header"
            to="/registration"><i class="material-icons">person_add</i> {{
              traduzione('item.sign.in') }}</router-link></li>

        <li class="nav-item active"><router-link @click.native="hideHeaderAndCloseSidenav"
            :exact-active-class="'main-link-active'" class="nav-link main-link nav-link-mobile remove-header"
            to="/login"><i class="material-icons">vpn_key</i> {{ traduzione('intem.login')
            }}</router-link></li>
      </template>

      <li class="divider"></li>

      <li class="nav-item active">
        <a class="dropdown-trigger" href="#!" data-target="language-mobile" ref="languageMobileDropdownTrigger">
          <img v-if="currentLanguageData && currentLanguageData.flag" :src="currentLanguageData.flag"
            :alt="currentLanguageData.language" class="flag-rounded">
            <span class="menu-side-bar-language">{{ traduzione(textLang)  }}</span>
          <i class="material-icons right">arrow_drop_down</i></a>
      </li>

      <li class="nav-item active" v-if="showMenu">
        <router-link @click.native="hideHeaderAndCloseSidenavCart" :exact-active-class="'main-link-active'"
          class="nav-link main-link nav-link-mobile remove-header"
          to="/cart">
          <i class="material-icons left">shopping_cart</i>
          {{ traduzione('item.menu.cart') || 'Carrello' }}
          <span v-if="cartCount > 0" class="new badge red cart-badge" data-badge-caption="">{{ cartCount }}</span>
        </router-link>
      </li>

    </ul>

    <EventMenu :imgHeader="getImageHeder()" v-if="eventSetting.getters.showHeader" />

  </div>
</template>
<script>
// ... (Tutto lo script fornito è corretto e mantenuto inalterato) ...
import translationStore from '@/store/translations'
import useAuthStore from '@/store/authStore.js'
import apiService from '@/services/apiService.js'
import M from 'materialize-css'
import eventSetting from '@/store/eventSettings.js'
import EventMenu from '@/components/EventMenu.vue'
import loadingStore from '@/store/loading'
// import { reloadTorefres } from '@/plugins/cookie-updater'

export default {
  name: 'app',
  components: {
    EventMenu
  },
  data () {
    return {
      eventSetting: eventSetting,
      translation: translationStore,
      useAuthStore: useAuthStore,
      sidenavInstance: null,
      textLang: null,
      // ⭐ STATO MANTENUTO: Contatore per il badge del carrello
      cartCount: 0
    }
  },
  computed: {
    traduzione () {
      return translationStore.getters.traduzione
    },
    showMenu () {
      return this.useAuthStore.getters.isAuthenticated
    },
    userName () {
      const userInfo = this.useAuthStore.getters.userInfo
      return userInfo ? userInfo.email : ''
    },
    currentLanguageData () {
      const currentCode = this.translation.getters.linguaCorrente
      const availableLanguages = this.translation.getters.avaiable
      return availableLanguages && availableLanguages[currentCode] ? availableLanguages[currentCode] : null
    }
  },
  methods: {
    async getTranslations (token, code) {
      try {
        const userLang = code.replace('-', '_')
        // const languageCode = code.substring(0, 2)
        // const url = process.env.VUE_APP_URL_LANG + '/' + userLang

        const url = '/api/translations/' + userLang
        const json = await apiService.sendRequestWithBearer('GET', url, token, null)

        translationStore.dispatch('caricaTraduzioni', json)
        const chiaveIt = Object.keys(this.translation.getters.avaiable).find(chiave => chiave === userLang)

        if (chiaveIt) {
          this.translation.dispatch('cambiaLingua', userLang)
        }
      } catch (error) {
        // L'errore nel caricamento della lingua è ignorato intenzionalmente
      }
    },
    // Metodo base per nascondere l'header
    hideHeader () {
      this.eventSetting.dispatch('showHeaderChange', false)
    },

    getImageHeder () {
      return eventSetting.getters.header
    },

    initializeMaterializeElements () {
      this.$nextTick(() => {
        // =========================
        // SIDENAV
        // =========================
        const sidenavElement = this.$refs.mobileSidenav
        if (sidenavElement && !this.sidenavInstance) {
          this.sidenavInstance = M.Sidenav.init(sidenavElement)
        }

        // =========================
        // DROPDOWN LINGUA (DESKTOP)
        // =========================
        if (
          this.$refs.languageDropdownTrigger &&
      document.getElementById('language') &&
      !M.Dropdown.getInstance(this.$refs.languageDropdownTrigger)
        ) {
          M.Dropdown.init(this.$refs.languageDropdownTrigger, {
            constrainWidth: false
          })
        }

        // =========================
        // DROPDOWN LINGUA (MOBILE)
        // =========================
        if (
          this.$refs.languageMobileDropdownTrigger &&
      document.getElementById('language-mobile') &&
      !M.Dropdown.getInstance(this.$refs.languageMobileDropdownTrigger)
        ) {
          M.Dropdown.init(this.$refs.languageMobileDropdownTrigger, {
            constrainWidth: false
          })
        }

        // =========================
        // DROPDOWN UTENTE (EMAIL)
        // =========================
        if (
          this.showMenu &&
      this.$refs.userDropdownTrigger &&
      document.getElementById('user') &&
      !M.Dropdown.getInstance(this.$refs.userDropdownTrigger)
        ) {
          const spanText =
        this.$refs.userDropdownTrigger.querySelector('.username-text')

          M.Dropdown.init(this.$refs.userDropdownTrigger, {
            constrainWidth: false,

            onOpenStart: () => {
              // Protezione anti-DOM rewrite Materialize
              if (
                spanText &&
            !this.$refs.userDropdownTrigger.contains(spanText)
              ) {
                this.$refs.userDropdownTrigger.prepend(spanText)
              }
            }
          })
        }
      })
    },

    // Metodo per chiudere la Sidenav
    closeSidenav () {
      if (this.sidenavInstance) {
        this.sidenavInstance.close()
      }
    },

    chartClick () {
      this.hideHeader()
      loadingStore.commit('setLoading', false)
    },

    hideHeaderAndCloseSidenavCart () {
      this.hideHeaderAndCloseSidenav()
      loadingStore.commit('setLoading', false)
    },
    // Metodo che chiude la Sidenav e nasconde l'header (usato sui router-link mobile)
    hideHeaderAndCloseSidenav () {
      this.hideHeader()
      this.closeSidenav()
    },

    // Metodo che chiama il logout, nasconde l'header e chiude la Sidenav (usato sull'item Logout mobile)
    async logoutAndHideHeaderAndCloseSidenav () {
      await this.logoutAndHideHeader()
      this.closeSidenav()
    },

    // Metodo originale di logout (usato sul dropdown desktop)
    async logoutAndHideHeader () {
      // 1. UI e Stato
      loadingStore.commit('setLoading', true)
      this.hideHeader()
      this.eventSetting.dispatch('resetEvents')

      // 2. Pulizia sessione (controlla che apiService.logout non faccia redirect!)
      apiService.logout()

      // 3. IL FIX: Rimuovi la variabile d'ambiente problematica.
      // Partendo con "/", il browser userà automaticamente il dominio corrente (test.igotu.it)
      const fanoutUrl = '/ajax/logout-fanout.php'

      console.log('Redirecting to:', fanoutUrl)
      window.location.replace(fanoutUrl)
    },

    // Metodo per aprire la sidenav mobile e impostare il testo della lingua
    fullLanguageAndHideHeader () {
      this.textLang = this.currentLanguageData ? this.currentLanguageData.language : ''
    },

    // Metodo base per cambiare lingua (usato nel dropdown desktop)
    async cambiaLinguaAndHideHeader (code) {
      loadingStore.commit('setLoading', true)

      if (!Object.hasOwn(translationStore.getters.linguapresente, code)) {
        const token = await apiService.getClientCredentialsToken()
        this.getTranslations(token, code)
      }

      this.translation.dispatch('cambiaLingua', code)
      loadingStore.commit('setLoading', false)
      // this.hideHeader() // Nasconde l'header
    },

    // Metodo che cambia lingua, nasconde l'header e chiude la Sidenav (usato nel dropdown mobile)
    async cambiaChiudiNavAndHideHeader (code) {
      await this.cambiaLinguaAndHideHeader(code)
      this.closeSidenav()
      if (this.$refs.languageMobileDropdownTrigger) {
        const instance = M.Dropdown.getInstance(this.$refs.languageMobileDropdownTrigger)
        if (instance) {
          instance.close()
        }
      }
    },

    // ⭐ METODO MANTENUTO: Legge 'listitem' da localStorage e aggiorna cartCount.
    updateCartDisplay () {
      try {
        const items = JSON.parse(localStorage.getItem('listitem') || '[]')
        this.cartCount = items.length
      } catch (e) {
        console.error("Errore nella lettura di 'listitem' da localStorage:", e)
        this.cartCount = 0
      }
    },

    /**
     * ⭐ METODO MANTENUTO: Gestisce gli eventi di storage globali.
     */
    handleStorageChange (event) {
      if (event.key === 'listitem' || !event.key) {
        this.updateCartDisplay()
      }
    },

    // Gestisce la rotazione/resize
    handleResize () {
      // Distruggi e resetta la Sidenav per forzare la ri-lettura del layout
      if (this.sidenavInstance) {
        this.sidenavInstance.destroy()
        this.sidenavInstance = null
      }
      // Re-inizializza tutti gli elementi (Sidenav e Dropdown)
      this.initializeMaterializeElements()
    }
  },
  watch: {
    showMenu (newValue) {
      if (!newValue && this.$refs.userDropdownTrigger) {
        const instance = M.Dropdown.getInstance(this.$refs.userDropdownTrigger)
        if (instance) instance.destroy()
      }

      this.$nextTick(() => {
        this.initializeMaterializeElements()
      })
    },
    'translation.getters.linguaCorrente': {
      handler () {
        this.fullLanguageAndHideHeader()
      },
      immediate: true
    }
  },
  mounted () {
    this.initializeMaterializeElements()
    window.addEventListener('resize', this.handleResize)

    // ⭐ Inizializza il contatore del carrello al mount
    this.updateCartDisplay()

    // ⭐ Ascolta i cambiamenti di localStorage (anche tra diverse tab/finestre)
    window.addEventListener('storage', this.handleStorageChange)
  },
  // ⭐ Pulisci i listener
  beforeUnmount () {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('storage', this.handleStorageChange)
  }
}
</script>

<style>
/* ... (Tutto lo stile fornito è corretto e mantenuto inalterato) ... */
/* Stile base della navbar */
nav {
  background-color: #000 !important;
}

/* CORREZIONE PER 1024x768 (Breakpoint 'l') */
@media only screen and (min-width: 993px) and (max-width: 1200px) {

  .nav-wrapper .left.hide-on-med-and-down li a,
  .nav-wrapper .right.hide-on-med-and-down li a {
    padding: 0 8px;
    font-size: 0.9rem;
  }

  .nav-wrapper .brand-logo {
    font-size: 1.8rem;
    transform: translateX(0%);
  }

  .nav-wrapper .right.hide-on-med-and-down li a.dropdown-trigger {
    font-size: 0.9rem;
  }

  .nav-wrapper .right.hide-on-med-and-down .flag-rounded {
    height: 18px;
    margin-top: 14px;
  }
}

/* CORREZIONE Z-INDEX (Sicurezza) */
.dropdown-content.correzione-drop-down-user,
.dropdown-content.correzione-drop-down,
.dropdown-content.correzione-drop-down-mobile {
  z-index: 10000 !important;
}

/* Menu utente troppo stretto in landscape */
.dropdown-content.correzione-drop-down-user {
  /* Imposta una larghezza minima per evitare che il testo vada a capo */
  min-width: 280px;
}

.dropdown-content.correzione-drop-down-user li > a,
.dropdown-content.correzione-drop-down-user li > a > i {
  /* Forza il testo (es. "Il mio account") a rimanere su una sola riga */
  white-space: nowrap;
}

/* ⭐ STILI MANTENUTI: Posizionamento del badge sul carrello */
.cart-badge {
    position: absolute;
    top: 5px; /* Sposta più in alto */
    right: 5px; /* Sposta più a destra */
    padding: 2px 5px !important;
    font-size: 0.7rem !important;
    line-height: 1 !important;
    min-width: 15px !important;
    height: 15px !important;
}

/* Aggiungi position: relative al link genitore per il posizionamento assoluto del badge */
.nav-wrapper .right.hide-on-med-and-down li a {
    position: relative;
}

/* Fix per l'allineamento verticale sull'icona mobile */
.sidenav .nav-link-mobile .new.badge {
    position: static;
    display: inline-block;
    vertical-align: top;
    margin-left: 5px;
}
</style>
